<template>
  <div>
     <v-layout wrap>
      <v-flex md3 xs12 >
     <SellerDashboard></SellerDashboard>
</v-flex>
      <v-flex md9 xs12>
     <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
    <v-card-title class="down pop">
      <b  class="prfont fontst">Pending Products</b>
    </v-card-title>

    <!-- <br> -->
  
      <v-row style="margin-left:20px;margin-right:20px;">
          
        <v-col md="4" v-for="i in data.slice(0,0)">
          <div v-if="i.status== 'Pending'">
           
            <div style="padding-top:0px;">
          
              <v-img :src="'https://api.inguzsales.in/u/' +i.photos[0]" height="156" width="auto" />
            </div>
            <!-- <v-img :src="'https://picsum.photos/300/300?random=1'+i.photo1" /> -->
            <v-card-title primary-title></v-card-title>
            <v-card-text>
              <div>
                <span style="font-size:20px;font-weight:500;color:black;">
                  <strong>{{i.productname}}</strong>
                </span>
                <star-rating style=""
                  v-bind:increment="1"
                  v-bind:star-size="14"
                  active-color="#ff4e00"
                  :read-only="true"
                  v-bind:rating="Math.floor(Math.random() * (5 - 1) + 1)"
                  required
                ></star-rating>
              </div>
              <v-flex md12>
                <v-row>
                  <v-col>
                    <span style="font-size:20px;color:black;">
                      <strong>₹{{i.price}}</strong>
                    </span>
                  </v-col>
                  <v-col>
                    <div v-if="i.instock">(In Stock)</div>
                    <div v-else>(Out of Stock)</div>
                  </v-col>
                </v-row>
              </v-flex>
              <span style="font-size:18px;font-weight:300;color:black;">
                <span>{{i.description}}</span>
                <!-- <br /> -->
              </span>
           
                
             
              <!-- <br /> -->

              <v-flex md12>
                <router-link :to="'/ProductView/' +i._id">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link>
                <v-row>
                  <v-col align="center">
                    
                  </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
         
          </div>
        </v-col>
      </v-row>
     </v-card>
      </v-flex>
      
    <br />
    </v-layout>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import AppSideNav from "@/components/common/AppSideNav";
import SellerDashboard from "@/components/common/SellerDashboard";

export default {
  props: ["id"],
  components: {
    AppSideNav,
    StarRating,
    SellerDashboard
  },
  data() {
    return {
      data: [],
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null
      }
    };
  },
  beforeMount() {
    this.getproducts();
  },
  methods: {
    getproducts() {
      axios({
        method: "GET",
        url: "/product/myproducts/",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.data = Response.data.data;

        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    }
  }
};
</script>

<style scoped>
.prfont{
  font-family: 'Montserrat';
}
</style>